import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import details_1 from '../../../assets/images/shop/product-slider-1.jpg'
import details_2 from '../../../assets/images/shop/product-slider-2.jpg'
import details_3 from '../../../assets/images/shop/product-slider-3.jpg'
import details_4 from '../../../assets/images/shop/product-slider-1.png'
import details_5 from '../../../assets/images/shop/product-slider-2.png'
import details_6 from '../../../assets/images/shop/product-slider-3.png'
import details_7 from '../../../assets/images/svg/header/Insta.svg'
import details_8 from '../../../assets/images/svg/header/Fb.svg'
import details_9 from '../../../assets/images/svg/header/Twiter.svg'
import details_10 from '../../../assets/images/svg/header/Pintrest.svg'
import details_11 from '../../../assets/images/blog/blog-details-3.jpg'
import details_12 from '../../../assets/images/blog/blog-details-4.jpg'
import details_13 from '../../../assets/images/shop/product-1.png'
import details_14 from '../../../assets/images/shop/product-2.png'
import details_15 from '../../../assets/images/shop/product-4.png'


const Details = () => {
    const [activeTab, setActiveTab] = useState('description-tab');


    return (
        <>
            <div className="shop-details-section">
                <div className="container">
                    <div className="row gutter-y-40">
                        <div
                            className="col-lg-6 animate fadeInLeft wow"
                            data-wow-duration="1500ms"
                            data-wow-delay="200ms"
                        >
                            <Slider className="product-slider" arrows={false} autoplay={true}>
                                <div className="product-slide-item">
                                    <img
                                        src={details_1}
                                        alt="product-image"
                                    />
                                    <div className="magnifier" />
                                </div>
                                <div className="product-slide-item">
                                    <img
                                        src={details_2}
                                        alt="product-image"
                                    />
                                    <div className="magnifier" />
                                </div>
                                <div className="product-slide-item">
                                    <img
                                        src={details_3}
                                        alt="product-image"
                                    />
                                    <div className="magnifier" />
                                </div>
                            </Slider>
                            <Slider className="product-thumb-slider" arrows={false} autoplay={true} slidesToShow={3}>
                                <div className="product-slide-thumb-item">
                                    <img
                                        width={100}
                                        height={100}
                                        src={details_4}
                                        alt="product-image"
                                    />
                                </div>
                                <div className="product-slide-thumb-item">
                                    <img
                                        width={100}
                                        height={100}
                                        src={details_5}
                                        alt="product-image"
                                    />
                                </div>
                                <div className="product-slide-thumb-item">
                                    <img
                                        width={100}
                                        height={100}
                                        src={details_6}
                                        alt="product-image"
                                    />
                                </div>
                                <div className="product-slide-thumb-item">
                                    <img
                                        width={100}
                                        height={100}
                                        src={details_5}
                                        alt="product-image"
                                    />
                                </div>
                            </Slider>
                        </div>
                        <div
                            className="col-lg-6 animate fadeInRight wow"
                            data-wow-duration="1500ms"
                            data-wow-delay="200ms"
                        >
                            <div className="pruduct-info">
                                <div className="product-title">
                                    <h4>Handbag</h4>
                                    <p>$120.00</p>
                                </div>
                                <div className="product-ratting-info">
                                    <ul className="retting">
                                        <li>
                                            <i className="fa-solid fa-star" />
                                        </li>
                                        <li>
                                            <i className="fa-solid fa-star" />
                                        </li>
                                        <li>
                                            <i className="fa-solid fa-star" />
                                        </li>
                                        <li>
                                            <i className="fa-solid fa-star" />
                                        </li>
                                        <li>
                                            <i className="fa-regular fa-star" />
                                        </li>
                                    </ul>
                                    <Link to="#" className="whishlist-box">
                                        <i className="fa-regular fa-heart" />
                                        <p>Add to wishlist</p>
                                    </Link>
                                </div>
                                <p>
                                    A collection of textile samples lay spread out on the table – Samsa
                                    was travelling salesman – and above it there hung a picture that he
                                    had recently cut out of an illustrated magazine and housed in a
                                    nice.
                                </p>
                                <div className="product-cart-info">
                                    <div className="product-cart-info-box">
                                        <Link to="#" className="minus">
                                            <i className="fa-solid fa-minus" />
                                        </Link>
                                        <span className="product-item-count">1</span>
                                        <Link to="#" className="plus">
                                            <i className="fa-solid fa-plus" />
                                        </Link>
                                    </div>
                                    <Link to="/Cart" className="btn btn-secondary">
                                        Add to cart <i className="fa-solid fa-cart-shopping" />
                                    </Link>
                                </div>
                                <ul className="product-info-list">
                                    <h5>Info Product</h5>
                                    <li>
                                        <p>SKU:&nbsp;</p>
                                        <span>03</span>
                                    </li>
                                    <li>
                                        <p>Category:&nbsp;</p>
                                        <span>&nbsp;Business Consulting</span>
                                    </li>
                                    <li>
                                        <p>Tags:&nbsp;</p>
                                        <span>&nbsp;Analysis,&nbsp;Corporate,&nbsp;Data</span>
                                    </li>
                                </ul>
                                <div className="social-media">
                                    <p>Follow : </p>
                                    <ul className="portfolio-details-social-media">
                                        <li>
                                            <Link to="https://www.instagram.com/">
                                                <img src={details_7} alt="icon" />
                                                <span>Instagram</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://www.facebook.com/">
                                                <img src={details_8} alt="icon" />
                                                <span>Facebook</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://x.com/">
                                                <img src={details_9} alt="icon" />
                                                <span>Twiter</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="https://www.pinterest.com/">
                                                <img src={details_10} alt="icon" />
                                                <span>Pintrest</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="product-desc-reviews">
                        <ul className="nav tabs product-desc-reviews-btn">
                            <li
                                className="wow fadeInLeft animated animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="300ms"
                            >
                                <Link
                                    className={`btn ${activeTab === "description-tab" ? "active" : ""}`}
                                    onClick={() => setActiveTab("description-tab")}
                                    id="description-tab"
                                    data-bs-toggle="tab"
                                    to="#description"
                                    aria-controls="description"
                                >
                                    Descriptions
                                </Link>
                            </li>
                            <li
                                className="wow fadeInLeft animated animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="100ms"
                            >
                                <Link
                                    className={`btn btn-transparent ${activeTab === "additional" ? "active" : ""}`}
                                    onClick={() => setActiveTab("additional")}
                                    id="additional"
                                    data-bs-toggle="tab"
                                    to="#additional"
                                    aria-controls="additional"
                                >
                                    Additional Information's
                                </Link>
                            </li>
                            <li
                                className="wow fadeInLeft animated animated"
                                data-wow-duration="1500ms"
                                data-wow-delay="100ms"
                            >
                                <Link
                                    className={`btn ${activeTab === "reviews-tab" ? "active" : ""}`}
                                    onClick={() => setActiveTab("reviews-tab")}
                                    id="reviews-tab"
                                    data-bs-toggle="tab"
                                    to="#reviews"
                                    aria-controls="reviews"
                                    tabIndex={-1}
                                >
                                    Reviews
                                </Link>
                            </li>
                        </ul>
                        <div className="tab-content">

                            <div
                                className={`tab-pane fade  ${activeTab === "description-tab" ? "active show" : ""}`}
                                id="description-tab"
                                role="tabpanel"
                                aria-labelledby="description-tab"
                            >
                                <div className="product-desc-wrapper">
                                    <div className="single-desc">
                                        <p
                                            className="lead wow fadeInUp animated animated"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="100ms"
                                        >
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                            enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                            nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                                            in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                                            nulla pariatur. Excepteur sint occaecat cupidatat non proident.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div
                                className={`tab-pane fade ${activeTab === "additional" ? "active show" : ""}`}
                                id="additional"
                                role="tabpanel"
                                aria-labelledby="additional-tab"
                            >
                                <div className="additional-wrapper">
                                    <div className="product-desc-wrapper">
                                        <div className="single-desc">
                                            <h3
                                                className="desc-title wow fadeInUp animated"
                                                data-wow-duration="1500ms"
                                                data-wow-delay="200ms"
                                                style={{
                                                    
                                                    animationDuration: "1500ms",
                                                    animationDelay: "200ms",
                                                    animationName: "none"
                                                }}
                                            >
                                                Additional information
                                            </h3>
                                            <p
                                                className="desc-text2 wow fadeInUp animated"
                                                data-wow-duration="1500ms"
                                                data-wow-delay="300ms"
                                                style={{
                                                    
                                                    animationDuration: "1500ms",
                                                    animationDelay: "300ms",
                                                    animationName: "none"
                                                }}
                                            >
                                                Circumstances occur in which toil and pain can procure him
                                                some great pleasure. To take a trivial example, which of us
                                                ever undertakes laborious physical exercise, except to obtain
                                                some advantage from it? But who has any right to find fault
                                                with a man who chooses
                                            </p>
                                            <ul
                                                className="product-desc-advantage wow fadeInUp animated"
                                                data-wow-duration="1500ms"
                                                data-wow-delay="400ms"
                                                style={{
                                                    
                                                    animationDuration: "1500ms",
                                                    animationDelay: "400ms",
                                                    animationName: "none"
                                                }}
                                            >
                                                <li>
                                                    <i className="icon icon-check" />
                                                    Modern Headphone
                                                </li>
                                                <li>
                                                    <i className="icon icon-check" />
                                                    Black Color
                                                </li>
                                                <li>
                                                    <i className="icon icon-check" />
                                                    Height Quality Products
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className={`tab-pane fade  ${activeTab === "reviews-tab" ? "active show" : ""}`}
                                id="reviews-tab"
                                role="tabpanel"
                                aria-labelledby="reviews-tab"
                            >
                                <div className="reviews-wrapper">
                                    <div className="row">
                                        <div
                                            className="col-lg-6 wow fadeInLeft animated"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="200ms"
                                        >
                                            <div className="comment-box">
                                                <h4>Review for this product</h4>
                                                <div className="comment-box-item">
                                                    <img
                                                        src={details_11}
                                                        alt="comment-image"
                                                    />
                                                    <div className="comment-box-details">
                                                        <div className="comment-meta-inner">
                                                            <div className="comment-meta">
                                                                <p>John Mathew</p>
                                                                <div className="reating-inner">
                                                                    <Link to="#">
                                                                        <i className="fas fa-star" />
                                                                    </Link>
                                                                    <Link to="#">
                                                                        <i className="fas fa-star" />
                                                                    </Link>
                                                                    <Link to="#">
                                                                        <i className="fas fa-star" />
                                                                    </Link>
                                                                    <Link to="#">
                                                                        <i className="fas fa-star" />
                                                                    </Link>
                                                                    <Link to="#">
                                                                        <i className="fas fa-star" />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <Link to="#" className="btn btn-primary btn-theme">
                                                                Reply
                                                            </Link>
                                                        </div>
                                                        <div className="comment-text">
                                                            <p>
                                                                Our achievements are rooted in fostering deep
                                                                collaboration and cultivating a global community of
                                                                diverse individuals who are dedicated.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="comment-box-item reply">
                                                    <img
                                                        src={details_12}
                                                        alt="comment-image"
                                                    />
                                                    <div className="comment-box-details">
                                                        <div className="comment-meta-inner">
                                                            <div className="comment-meta">
                                                                <p>Alina. R</p>
                                                                <div className="reating-inner">
                                                                    <Link to="#">
                                                                        <i className="fas fa-star" />
                                                                    </Link>
                                                                    <Link to="#">
                                                                        <i className="fas fa-star" />
                                                                    </Link>
                                                                    <Link to="#">
                                                                        <i className="fas fa-star" />
                                                                    </Link>
                                                                    <Link to="#">
                                                                        <i className="fas fa-star" />
                                                                    </Link>
                                                                    <Link to="#">
                                                                        <i className="fas fa-star" />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <Link to="#" className="btn btn-primary btn-theme" >
                                                                Reply
                                                            </Link>
                                                        </div>
                                                        <div className="comment-text">
                                                            <p>
                                                                Achievements are rooted in fostering deep
                                                                collaboration and cultivating a global community of
                                                                diverse individuals who are dedicated.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="col-lg-6 wow fadeInRight animated"
                                            data-wow-duration="1500ms"
                                            data-wow-delay="200ms"
                                        >
                                            <div className="comment-form-box">
                                                <h4>Add a Review</h4>
                                                <p>
                                                    Your email address will not be published. Required fields
                                                    are marked*
                                                </p>
                                                <div className="reating-inner">
                                                    <Link to="#">
                                                        <i className="fas fa-star" />
                                                    </Link>
                                                    <Link to="#">
                                                        <i className="fas fa-star" />
                                                    </Link>
                                                    <Link to="#">
                                                        <i className="fas fa-star" />
                                                    </Link>
                                                    <Link to="#" >
                                                        <i className="fas fa-star" />
                                                    </Link>
                                                    <Link to="#" >
                                                        <i className="fas fa-star" />
                                                    </Link>
                                                </div>
                                                <form action="#">
                                                    <div className="comment-form-group-one">
                                                        <div className="comment-form-group-one-inner">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Name"
                                                                required=""
                                                            />
                                                        </div>
                                                        <div className="comment-form-group-one-inner">
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Email"
                                                                required=""
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="comment-form-group-one">
                                                        <textarea
                                                            name="comment"
                                                            rows={4}
                                                            className="form-control"
                                                            placeholder="Comments"
                                                            required=""
                                                            defaultValue={""}
                                                        />
                                                    </div>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-secondary btn-theme"
                                                    >
                                                        Leave A Review
                                                    </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>

                    </div>
                    <div className="releted-product">
                        <h4>Related Products</h4>
                        <div className="row gutter-y-40">
                            <div className="col-lg-4 col-md-6">
                                <div
                                    className="product-box animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    <div className="product-image">
                                        <img src={details_13} alt="product-image" />
                                        <ul className="cart-icon">
                                            <li>
                                                <Link to="/ProdectDetails">
                                                    <i className="fa-solid fa-cart-shopping" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/Cart">
                                                    <i className="fa-solid fa-heart" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="product-details">
                                        <h4>
                                            <Link to="/ProdectDetails">White Bottle</Link>
                                        </h4>
                                        <p>$120.00</p>
                                        <ul className="product-retting">
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div
                                    className="product-box animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="400ms"
                                >
                                    <div className="product-image">
                                        <img src={details_14} alt="product-image" />
                                        <Link to="/ProdectDetails" className="offer">
                                            Sale
                                        </Link>
                                        <ul className="cart-icon">
                                            <li>
                                                <Link to="/ProdectDetails">
                                                    <i className="fa-solid fa-cart-shopping" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/Cart">
                                                    <i className="fa-solid fa-heart" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="product-details">
                                        <h4>
                                            <Link to="/ProdectDetails">Amazon Portable Speaker</Link>
                                        </h4>
                                        <p>$120.00</p>
                                        <ul className="product-retting">
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-regular fa-star" />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div
                                    className="product-box animate fadeInRight wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="600ms"
                                >
                                    <div className="product-image">
                                        <img src={details_15} alt="product-image" />
                                        <ul className="cart-icon">
                                            <li>
                                                <Link to="/ProdectDetails">
                                                    <i className="fa-solid fa-cart-shopping" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/Cart">
                                                    <i className="fa-solid fa-heart" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="product-details">
                                        <h4>
                                            <Link to="/ProdectDetails">Amazon Portable Speaker</Link>
                                        </h4>
                                        <p>$120.00</p>
                                        <ul className="product-retting">
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                            <li>
                                                <i className="fa-solid fa-star" />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )

}


export default Details